export default class Helper {

    setProtection($checkbox, langPostfix, configuratorStore) {
        let $protection = $('#pa_extra-protection');
        let value = `no${langPostfix}`;

        if($checkbox.is(':checked')) {
            value = `yes${langPostfix}`;
        }

        configuratorStore.set('protection', value);

        if($protection.val() !== value) {
            $protection.val(value);
            $protection.trigger('change');
        }
    }

    configuratorToggleSubmit(configuratorStore, configuratorValidation) {
        let price = '';
        let $price = $('.single_variation_wrap ins .amount');

        if($price.length) {
            price = $price.html();
        }else {
            price = $('.single_variation_wrap .amount').html()
        }

        let isDisabled = $('.single_add_to_cart_button').is('.disabled');
        let $total = $('.configurator-step.total');
        let $box = $total.find('.box');
        let label = $box.attr('data-amount');
        let $submit = $('.configurator-footer .btn');
        let display = 'none';
        let validationData = configuratorStore.all();

        if(configuratorStore.get('protection') === 'yes') {
            label = $box.attr('data-protection');
        }

        $total.find('.label').html(label);
        $total.find('.price').html(price);
        $total.css({
            'disabled': isDisabled
        });

        let existProtection = $('#configurator_protection').is(':checked');

        if((isDisabled || !configuratorValidation.isValid(validationData)) && $('#configurator_select_price').length) {
            $submit.addClass('disabled');
        }else {
            $submit.removeClass('disabled');
            display = existProtection || !$('#configurator_select_price').length ? 'block' : 'none';
        }

        $submit.css({
            'disabled': isDisabled
        });

        display = 'block';

        if(existProtection || display === 'none') {
            $total.css({
                'display': display
            });
        }
    }
}